export type LeaveView = 'approvals' | 'list' | 'calendar' | 'statistics' | 'sick-report' | 'shutdown'
export type LeaveScope = 'my' | 'team' | 'all'

const VALID_LEAVE_VIEWS = new Set<LeaveView>([
  'approvals',
  'list',
  'calendar',
  'statistics',
  'sick-report',
  'shutdown',
])

export function getLeaveViewFromSearch(search: string): LeaveView {
  const value = new URLSearchParams(search).get('tab')
  return VALID_LEAVE_VIEWS.has(value as LeaveView) ? (value as LeaveView) : 'list'
}

export function leaveViewPath(view: LeaveView): string {
  if (view === 'shutdown') return '/shutdown-skeleton-crew'
  return view === 'list' ? '/leave' : `/leave?tab=${view}`
}

export function getLeaveScopeFromSearch(
  search: string,
  { isDivisionLeader, isLeaveAdmin }: { isDivisionLeader: boolean; isLeaveAdmin: boolean }
): LeaveScope {
  const requested = new URLSearchParams(search).get('scope')
  if (requested === 'my') return 'my'
  if (requested === 'team' && isDivisionLeader) return 'team'
  if (requested === 'all' && isLeaveAdmin) return 'all'

  if (isDivisionLeader) return 'team'
  if (isLeaveAdmin) return 'all'
  return 'my'
}

export function leaveScopePath(scope: LeaveScope): string {
  return `/leave?scope=${scope}`
}
